import type { FileRoutesByTo } from "@/routeTree.gen";

/**
 * Bestemmer rekkefølgen på sidene i bestillingsprosessen.
 */
export const bestillingFormPageOrder = [
  "/bestilling/ny/informasjon",
  "/bestilling/ny/finn-leverandoer",
  "/bestilling/ny/aktoer",
  "/bestilling/ny/periode",
  "/bestilling/ny/bestiller",
  "/bestilling/ny/oppsummering",
] as const satisfies (keyof FileRoutesByTo)[];

export type BestillingPageKey = (typeof bestillingFormPageOrder)[number];
